import styled from '@emotion/styled';
import { Box, BoxProps } from '@hover/blueprint';
import React from 'react';

const StyledProgress = styled(Box)`
  position: absolute;
  width: 0;
  top: -1px;
  height: 4px;
  animation: fillProgress linear infinite;
  animation-duration: ${(props: { duration: number }) => `${props.duration}s`};

  @keyframes fillProgress {
    from {
      width: 0;
    }
    to {
      width: 100%;
    }
  }
`;

interface Props extends BoxProps {
  duration?: number;
  barColor?: string;
}

const Progress: React.FC<Props> = ({ duration, barColor, ...rest }) => (
  <Box h="1px" w="100%" position="relative" bg="neutral.300" {...rest}>
    <StyledProgress duration={duration ?? 10} bg={barColor} />
  </Box>
);

Progress.defaultProps = {
  duration: 10,
  barColor: 'brandNavy.500',
};

export default Progress;
